import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { EffectiveUserHolidayDto } from "./effective-user-holiday.dto";
import { CreateUserChangeHolidayDto } from "./create-user-change-holiday.dto";
import { UpdateUserChangeHolidayDto } from "./update-user-change-holiday.dto";
import { HttpRequest } from "@/core/common/http/http-request";
import { plainToInstance } from "class-transformer";
import { UserChangeHolidayDto } from "./user-change-holiday.dto";

export class UserChangeHolidaysResource extends ResourceBaseService<
  UserChangeHolidayDto,
  CreateUserChangeHolidayDto,
  UpdateUserChangeHolidayDto
> {
  protected EntityDto = UserChangeHolidayDto;
  protected CreateEntityDto = CreateUserChangeHolidayDto;
  protected UpdateEntityDto = UpdateUserChangeHolidayDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/user-change-holidays");
  }

  async listEffectiveByUserAndYear(userId: string, year: number): Promise<EffectiveUserHolidayDto[]> {
    const query = new URLSearchParams({ userId, year: year.toString() }).toString();
    const result = await this.apiHttpClient.request<null, EffectiveUserHolidayDto[]>(
      HttpRequest.create({
        url: `${this.resourceUrl}/effective`,
        method: "GET",
        auth: true,
        query,
      })
    );
    return plainToInstance(EffectiveUserHolidayDto, result);
  }
}
